<template>
  <div id="app">
    <div v-if="isAuthenticated">
      <div class="app">

        <AppHeader fixed>
          <SidebarToggler class="d-lg-none" display="md" mobile />
          <b-link class="navbar-brand medium-hide small-hide mobile-hide" to="#">
            <img class="navbar-brand-full" :src="origin + '/img/logo2024.png'" width="89" height="25" alt="CoreUI Logo">
            <img class="navbar-brand-minimized" :src="origin + '/img/brand/sygnet.svg'" width="30" height="30" alt="CoreUI Logo">
          </b-link>
          <SidebarToggler class="d-md-down-none" display="lg" />

          <span v-if="authUser && authUser.companyGroup" class="text-muted ml-lg-3 ml-0">
            {{ authUser.companyGroup.alias }}
          </span>

          <b-navbar-nav class="ml-auto">
            <b-dropdown v-if="bellNotifications" id="notifications-dropdown" variant="link" no-caret toggle-class="text-decoration-none">
              <template #button-content>
                <div id="notification-bell">
                  <i class="icon-bell"></i>
                  <b-badge v-if="numberOfUnreadNotifications" pill variant="danger">
                    {{numberOfUnreadNotifications}}
                  </b-badge>
                </div>
              </template>
              <b-dropdown-item v-for="(n, index) in bellNotifications" :key="index" :class="{ 'bg-secondary': n.read }">
                <div class="row px-0 notification-row align-items-center" @click="openNotification(index)">
                  <div c-if="n.title" class="col-12 notification-title">
                    {{n.title}}
                  </div>
                  <div class="col-12 notification-message">
                    {{n.message}}
                  </div>
                  <a href="#" class="col-12 notification-link">
                    {{n.link}}
                  </a>
                </div>
              </b-dropdown-item>
              <b-dropdown-item v-if="!bellNotifications.length">
                Nenhuma Mensagem Nova
              </b-dropdown-item>
              <div v-if="areNewMessagesAvailable">
                <button type="button" class="btn btn-link text-center" style="display: block; width: 100%;" :disabled="loadingNotifications"
                  @click="getMessages">
                  Carregar
                </button>
              </div>
            </b-dropdown>

            <div class="mr-2">
              <span v-if="loadingNotificationToggle">
                Carregando...
              </span>
              <span v-else>
                <span v-if="!activeNotifications">
                  <button v-on:click="activateNotifications()" type="button" class="btn btn-link btn-sm">
                    <i class="icon-info"></i>
                    Ativar Notificações
                  </button>
                </span>
                <span v-if="activeNotifications">
                  <button v-on:click="disableNotifications()" type="button" class="btn btn-link btn-sm">
                    <i class="icon-info"></i>
                    Desativar Notificações
                  </button>
                </span>
              </span>
            </div>

            <div class="mr-2">
              <span v-if="loadingSyncPanel" class="badge badge-secondary">Carregando...</span>
              <span v-else-if="syncPanel && syncPanel.formattedSyncDate" :class="{ 'text-danger font-weight-bold': syncPanel.isSyncDelayed }">
                <small class="text-muted mr-1 mobile-hide">Última sinc.:</small>
                <i v-if="syncPanel.isSyncDelayed" class="fa fa-exclamation-triangle text-danger mr-1"></i>{{syncPanel.formattedSyncDate}}
              </span>
            </div>

            <!-- <div class="mr-2">
              <span v-if="loadingConnection" class="badge badge-secondary">Carregando...</span>
              <span v-else-if="connection && !connection.inativo" class="badge badge-success">Fênix Online</span>
              <span v-else class="badge badge-danger">Fênix Offline</span>
            </div> -->

            <DefaultHeaderDropdownAccnt :authUser="authUser"/>
          </b-navbar-nav>
        </AppHeader>

        <div class="app-body">
          <AppSidebar fixed>
            <SidebarHeader/>

            <SidebarForm/>

            <SidebarNav :navItems="navItems"></SidebarNav>

            <SidebarFooter/>

            <SidebarMinimizer/>
          </AppSidebar>

          <main class="main">
            <Breadcrumb :list="list"/>

            <div class="container-fluid no-small-padding no-mobile-padding">
              <b-row>
                <b-col>
                  <div class="animated bounce">
                    <b-card class="card-accent-info main-card-body" :header="title">
                      <router-view></router-view>
                    </b-card>
                  </div>
                </b-col>
              </b-row>

              <item-details-modal />
            </div>
          </main>
        </div>

        <vue-snotify></vue-snotify>

        <TheFooter>
          <div>
            <span class="ml-1">Teorema {{new Date().getFullYear()}}. Versão {{currentVersion}}</span>
          </div>
        </TheFooter>
      </div>
    </div>

    <NotAuthenticated v-else :authFrontUrl="authFrontUrl" />

    <ContextMenu />
  </div>
</template>

<script>
  import { items } from '@/tools/_nav'
  import Retry from '@/components/common/retry'
  import { mapState, mapGetters } from 'vuex'
  import { httpClient } from '@/service';
  import { auth } from '@/service';
  import {
    Aside as AppAside,
    AsideToggler,
    Breadcrumb,
    Footer as TheFooter,
    Header as AppHeader,
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
    SidebarToggler,
  } from '@coreui/vue'
  import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
  import { setTimeout, clearTimeout } from 'timers';
  import shared from '@/shared/shared';
  import ContextMenu from "../components/common/ContextMenu.vue";
  import { version } from '../../package.json';
  import Axios from 'axios';
  import firebase from 'firebase/app';
  import NotAuthenticated from "@/components/common/NotAuthenticated";
  import "firebase/messaging";
  import jscookies from 'js-cookie';
  import ItemDetailsModal from '@/components/common/item-details-modal';

  export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    Retry,
    ContextMenu,
    NotAuthenticated,
    ItemDetailsModal
  },

  data() {
    return {
      authUser: null,
      isAuthenticated: false,
      //ordersCounts: {},
      navItems: [],
      //ordersCountsTimeout: null,
      fiveMin: 300000,
      connection: null,
      cliforCodigo: null,
      loadingConnection: false,
      syncPanel: null,
      loadingSyncPanel: false,
      currentVersion: version,
      origin: window.location.origin,
      activeNotifications: null,
      messaging: null,
      loadingNotificationToggle: false,
      bellNotifications: [],
      numberOfUnreadNotifications: 0,
      loadingNotifications: false,
      notificationsPage: 1,
      allUnreadNotificationsLoaded: false,
      areNewMessagesAvailable: true,
      authFrontUrl: process.env.VUE_APP_AUTH_FRONT_URL
    }
  },

  mounted: function () {
    this.currentVersion = version;
    this.authUser = shared.getLocalStorageObj('auth/user');
    this.activeNotifications = jscookies.get(this.activeNotificationsKey);
    this.reloadNavItems();
    this.updateIsAuthenticated();
    //this.reloadOrdersCounts();
    this.getMessaging();

    if (this.messaging) {
      this.hasToken();

      navigator.serviceWorker.addEventListener('message', (event) => {
        //console.log(event);
        let res = JSON.parse(event.data.data.body);
        new Notification (
          res.title, {
            body: res.message + ' - ' + res.link,
            icon: res.icon,
            tag: "Dummy"
          }
        );

        if (!this.bellNotifications) {
          this.bellNotifications = [];
        }

        if (!this.bellNotifications.filter(n => n._id === res._id).length) {
          this.bellNotifications.unshift(res);
          this.numberOfUnreadNotifications++;
        }
      });
    }

    if (this.authUser && this.authUser.token) {
      this.updateConnection();

      /*setInterval(() => {
        if (this.authUser && this.authUser.token) {
        this.authUser = shared.getLocalStorageObj('auth/user');
        this.updateIsAuthenticated();

        httpClient.put(`${process.env.VUE_APP_AUTH_API_URL}/refresh`, this.authUser)
          .then(({ data }) => {
            shared.fetchAuthUser(data.data.id, this.authUser.token).then(user => {
              this.authUser = user;
              this.updateIsAuthenticated();
              this.updateConnection();
            }).catch(error => {
              if (error.message) {
                this.$notify.error(error)
              }
            });
          })
          .catch((error) => {
            if (error.message) {
              this.$notify.error(error)
            }
          });
        }
      }, this.fiveMin);*/

      /*this.$root.$on('reloadOrdersCounts', () => {
        if (this.ordersCountsTimeout) {
          clearTimeout(this.ordersCountsTimeout);
        }

        this.reloadOrdersCounts();
      });*/
    } else {
      this.redirectToIndex();
    }

    this.getMessages();
  },

  watch: {
    notifications (notifications) {
      notifications.forEach(notification => {
        if (notification.body.fieldErrors) {
          notification.body.fieldErrors.forEach(error => {
            this.$snotify[notification.type](error.message, error.field, notification.config)
          })
        } else {
          this.$snotify[notification.type](notification.body, notification.title, notification.config)
        }
      })
    },
  },

  computed: {
    ...mapState('app', {
      title: ({ current_page }) => current_page.title,
      size: ({ current_page }) => current_page.size,
      notifications: ({ notifications }) => notifications,
    }),

    name () {
      return this.$route.name
    },

    list () {
      let routes = [];

      if (this.$route && this.$route.matched && this.$route.matched.length) {
        let home = this.$route.matched[0];
        routes.push(home);
        routes.push(...this.getBreadcrumbChildrenRoutes(home.meta.breadcrumbChildren));
      }

      return routes;
    },

    activeNotificationsKey() {
      return `active-notifications-${this.authUser.id}`;
    },

    firebaseTokenKey() {
      return 'firebase-token-' + this.authUser.id;
    }
  },

  methods: {
    redirectToIndex() {
      auth.redirectToLogin();
    },

    updateIsAuthenticated() {
      this.isAuthenticated = this.authUser && this.authUser.token && this.authUser.token.length;
    },

    getBreadcrumbChildrenRoutes(breadcrumbChildren) {
      let routes = [];

      if (breadcrumbChildren && breadcrumbChildren.length) {
        for (let i = 0; i < breadcrumbChildren.length; i++) {
          routes.push(...this.getBreadcrumbChildRoutes(breadcrumbChildren[i]));
        }
      }

      return routes;
    },

    getBreadcrumbChildRoutes(breadcrumbChild) {
      let routes = [];

      for (let j = 0; j < this.$route.matched.length; j++) {
        let currentRoute = this.$route.matched[j];

        if (currentRoute.path.startsWith(breadcrumbChild)) {
          routes.push(...this.getRouteBreadCrumbParent(currentRoute));
          routes.push(currentRoute);

          break;
        }
      }

      return routes;
    },

    getRouteBreadCrumbParent(route) {
      let routes = [];

      if (route.meta.breadcrumbParent) {
        if (route.meta.breadcrumbParent.meta) {
          routes.push(...this.getRouteBreadCrumbParent(route.meta.breadcrumbParent));
        }

        routes.push(route.meta.breadcrumbParent);
      }

      return routes;
    },

    //reloadOrdersCounts() {
      /*httpClient.get(`${process.env.VUE_APP_API_URL}orders/counts`)
      .then(({ data }) => {
        this.ordersCounts = data.data;
        this.reloadNavItems();*/

        /*this.ordersCountsTimeout = setTimeout(() => {
          this.reloadOrdersCounts();
        }, this.fiveMin);*/
      /*})
      .catch((error) => {
        if (error.message) {
          this.$notify.error(error)
        }*/

        /*this.ordersCountsTimeout = setTimeout(() => {
          this.reloadOrdersCounts();
        }, this.fiveMin);*/
      //});
    //},

    reloadNavItems() {
      this.navItems = items(/*this.ordersCounts, */this.authUser);

      let navItems = this.navItems;
      this.navItems = [];

      this.$nextTick(() => {
        this.navItems = navItems;
      });
    },

    getCliforCodigo() {
      if (this.authUser && this.authUser.companyGroup && this.authUser.companyGroup.ref) {
        let underscoreIndex = this.authUser.companyGroup.ref.indexOf('_');

        if (underscoreIndex > -1 && underscoreIndex < this.authUser.companyGroup.ref.length - 1) {
          this.cliforCodigo = '0001_' + this.authUser.companyGroup.ref.substring(underscoreIndex + 1);
        }
      }
    },

    updateConnection() {
      /*this.getCliforCodigo();

      if (this.cliforCodigo && this.cliforCodigo.length) {
        this.loadingConnection = true;
        httpClient.get(`${process.env.VUE_APP_SOCKETIO_URL}poll/customer/${this.cliforCodigo}/fenix`)
        .then(({ data }) => {
          this.loadingConnection = false;

          i
  }
        .catch((error) => {
          this.loadingConnection = false;
          if (error.message) {
            this.$notify.error(error)
          }
          this.connection = null;
        });
      }*/

      this.loadingSyncPanel = true;
      httpClient.get(`${process.env.VUE_APP_API_URL}sync-panels`)
      .then(({ data }) => {
        this.loadingSyncPanel = false;

        if (data && data.data) {
          if (data.data.syncDate) {
            data.data.syncDate = new Date(data.data.syncDate);
            data.data.isSyncDelayed = data.data.syncDate.getTime() < new Date().getTime() - 3600000;
            data.data.formattedSyncDate = shared.formatDate(data.data.syncDate, {
              returnAccordingToCurrentDay: true,
              includeSeconds: false,
              omitYearIfCurrent: true
            });
          }

          this.syncPanel = data.data;
        }
      })
      .catch((error) => {
        this.loadingSyncPanel = false;
        if (error.message) {
          this.$notify.error(error)
        }
        this.syncPanel = null;
      });
    },

    hasToken() {
      this.getMessaging();

      if (this.messaging) {
        let lastToken = jscookies.get(this.firebaseTokenKey);

        this.messaging.getToken().then(currentToken => {
          if (currentToken && currentToken != lastToken) {
            jscookies.set(this.firebaseTokenKey, currentToken);

            this.deleteSubscriber(lastToken);
            this.postSubscriber(currentToken);
          }
        }).catch((err) => {
          console.log('Error to get token', err);
        });
      }
    },

    deleteSubscriber (token) {
      this.loadingNotificationToggle = true;
      Axios({
        url: process.env.VUE_APP_REDLINE_API + 'subscribers/delete-token/' + token,
        method: 'DELETE'
      }).then(response => {
        this.loadingNotificationToggle = false;
        jscookies.remove(this.activeNotificationsKey);
        this.activeNotifications = jscookies.get(this.activeNotificationsKey);
        this.$notify.success("Notificações desativadas");
      }).catch((error) => {
        this.loadingNotificationToggle = false;
        if (error.message) {
          this.$notify.error(error);
        }
      });
    },

    postSubscriber (token){
      this.loadingNotificationToggle = true;
      Axios({
        url: process.env.VUE_APP_REDLINE_API + 'subscribers',
        method: 'POST',
        data: {
          "user_id": this.authUser.id,
          "type": "firebase",
          "value": token
        }
      }).then(response => {
        this.loadingNotificationToggle = false;
        jscookies.set(this.activeNotificationsKey, 'true');
        this.activeNotifications = jscookies.get(this.activeNotificationsKey);
        this.$notify.success("Notificações ativadas");
      }).catch((error) => {
        this.loadingNotificationToggle = false;
        if (error.message) {
          this.$notify.error(error);
        }
      });
    },

    activateNotifications () {
      try {
        this.loadingNotificationToggle = true;
        this.getMessaging();

        if (this.messaging) {
          this.messaging.getToken().then(currentToken => {
            this.loadingNotificationToggle = false;

            if (currentToken) {
              jscookies.set(this.firebaseTokenKey, currentToken);
              this.postSubscriber(currentToken);
            }
          }).catch((err) => {
            this.loadingNotificationToggle = false;
            console.log('Error to get token', err);
          });

          if (Notification.permission !== 'granted') {
            Notification.requestPermission();
          }
        } else {
          console.log('firebase messaging not supported');
          this.loadingNotificationToggle = false;
        }
      } catch (err) {
        this.loadingNotificationToggle = false;
        console.log(err);
      }
    },

    disableNotifications () {
      let token = jscookies.get(this.firebaseTokenKey);
      this.deleteSubscriber(token);
    },

    getMessages() {
      if (this.loadingNotifications) {
        return;
      }

      this.loadingNotifications = true;
      httpClient.get(`${process.env.VUE_APP_REDLINE_API}notification/${this.authUser.id}?page=${this.notificationsPage}`)
      .then(({ data }) => {
        this.loadingNotifications = false;

        if (data && data.data && data.data.length) {
          this.notificationsPage = data.current_page + 1;

          if (!this.allUnreadNotificationsLoaded) {
            this.numberOfUnreadNotifications += data.data.filter(n => !n.read).length;

            if (data.current_page >= data.last_page) {
              this.allUnreadNotificationsLoaded = true;
              this.notificationsPage = 1;
            }
          } else {
            if (data.current_page >= data.last_page) {
              this.areNewMessagesAvailable = false;
            }
          }

          if (!this.bellNotifications) {
            this.bellNotifications = [];
          }

          data.data.forEach(message => {
            if (!this.bellNotifications.filter(n => n._id === message._id).length) {
              this.bellNotifications.push(message);
            }
          });
        } else if (!this.allUnreadNotificationsLoaded) {
          this.allUnreadNotificationsLoaded = true;
          this.notificationsPage = 1;
        } else {
          this.areNewMessagesAvailable = false;
        }
      })
      .catch((error) => {
        this.loadingNotifications = false;
        if (error.message) {
          this.$notify.error(error)
        }
      });
    },

    openNotification(index) {
      let readNotificationsOfTheSameTicket = [ this.bellNotifications[index] ];

      if (this.bellNotifications[index].link && this.bellNotifications[index].link.length) {
        window.open(this.bellNotifications[index].link);
        readNotificationsOfTheSameTicket = this.bellNotifications.filter(n => {
          return !n.read && n.link && n.link === this.bellNotifications[index].link
        });
      }

      if (readNotificationsOfTheSameTicket.length) {
        let ids = readNotificationsOfTheSameTicket.map(n => n._id);

        httpClient.patch(`${process.env.VUE_APP_REDLINE_API}notification/read/multiple`, ids)
        .then(({ data }) => {
          this.numberOfUnreadNotifications -= readNotificationsOfTheSameTicket.length;

          this.bellNotifications.forEach(n => {
            if (ids.includes(n._id) && !n.read) {
              n.read = true;
            }
          });
        }).catch((error) => {
          if (error.message) {
            this.$notify.error(error)
          }
        });
      }
    },

    getMessaging() {
      if (!this.messaging && firebase.messaging.isSupported()) {
        this.messaging = firebase.messaging();
      }

      return this.messaging;
    }

    //TODO
    /*onChangeCompanyGroup(companyGroup) {
    this.authService.setCompanyGroup(companyGroup)
     this.window.location.reload()
    }*/
  }
}
</script>

<style>
#notification-bell {
  color: #73818f;
}

#notification-bell .badge {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -16px;
  margin-left: 0;
}

#notifications-dropdown .dropdown-menu {
  overflow: scroll !important;
  max-height: 75vh !important;
}

.dropdown-item {
  white-space:normal;
}

.notification-title {
  font-size:13px;
  text-align: center;
  color: #3b7203;
}

.notification-message {
  font-size:13px;
  text-align: justify;
  word-wrap: normal;
  letter-spacing: 1px;
  width: 20vw;
}

.notification-link {
  font-size: 13px;
  text-decoration: none;
  color: #008CBA;
}

.notification-row {
  border-bottom: 1px solid #10135e29;
}
</style>
